import { type QuoteContextRequest } from '@airship-platform/organization-integrations/schema';
import { useCallback, useState } from 'react';
import { useHttpClient } from '../contexts';

export enum RewriteOption {
  IMPROVE_WRITING = 'improve',
  MAKE_LONGER = 'longer',
  MAKE_SHORTER = 'shorter',
  MORE_FRIENDLY = 'friendly',
  MORE_PROFESSIONAL = 'professional',
}

export enum QuoteContext {
  BIO = 'BIO',
  PRODUCT_DESCRIPTION = 'PRODUCT_DESCRIPTION',
  PROPOSAL_NOTES = 'PROPOSAL_NOTES',
  PROPOSAL_SUMMARY_INVITATION = 'PROPOSAL_SUMMARY_INVITATION',
  PROPOSAL_FOLLOW_UP_MESSAGE = 'PROPOSAL_FOLLOW_UP_MESSAGE',
  PROPOSAL_SUMMARY = 'PROPOSAL_SUMMARY',
  PROPOSAL_OPTION_SUMMARY = 'PROPOSAL_OPTION_SUMMARY',
  PROPOSAL_TEMPLATE_OPTION_SUMMARY = 'PROPOSAL_TEMPLATE_OPTION_SUMMARY',
}

type AIGeneratorResponse = {
  improvedQuote: string;
  reasoning: string;
};

export const useAIGenerator = () => {
  const [isLoadingOption, setIsLoadingOption] = useState<RewriteOption>();
  const [error, setError] = useState<string>();
  const httpClient = useHttpClient();

  const generateQuote = useCallback(
    async (
      sourceQuote: string,
      rewriteOption: RewriteOption,
      quoteContext: QuoteContext,
      contextData?: QuoteContextRequest
    ) => {
      setError(undefined);
      setIsLoadingOption(rewriteOption);

      try {
        const res = await httpClient.post<AIGeneratorResponse[]>(
          `/organization-integrations/quote-genai`,
          {
            sourceQuote: sourceQuote.trim(),
            rewriteOption,
            quoteContext,
            contextData,
          }
        );

        return res;
      } catch (error) {
        setError(String(error));
        return [];
      } finally {
        setIsLoadingOption(undefined);
      }
    },
    [httpClient]
  );

  return {
    isLoadingOption,
    error,
    generateQuote,
  };
};
